const projectColors = {
  '0': ['D62121', 'FB6B6B'],
  '1': ['D64121', 'FF7557'],
  '2': ['D27911', 'FFB36C'],
  '3': ['CEB011', 'FFD15C'],
  '4': ['17AF26', '75ED2B'],
  '5': ['159B4B', '1BDA67'],
  '6': ['12B890', '42F3D3'],
  '7': ['3A65D1', '5F8AFA'],
  '8': ['4D49CD', '6E6BEC'],
  '9': ['7031BF', 'A46BEC'],
  '10': ['BF21C2', 'FC6CFF'],
  '11': ['C2216F', 'FF6CC4'],
}

export default projectColors;
